import React from "react";
import ReactDOM from "react-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// import { Router, Route, Switch, Redirect } from "react-router-dom";

import App from "./App/index";
// import App from "../src/Demo/Authentication/SignIn/SignIn";
import * as serviceWorker from "./serviceWorker";
import reducer from "./store/reducer";
import config from "./config";
import "../src/assets/css/common.css";
import "../src/assets/css/styles.css";

const store = createStore(reducer);

const app = (
  //store을 만듦 - Redux의 createStore API를 사용하고, createStore의 입력값은 Reducer함수.
  // <Provider> React 컴포넌트가 storedp 접근 권한을 얻게 됨
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
      {/* basename="/datta-able" */}
      <App />
    </BrowserRouter>
  </Provider>
);
ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
